import { dateFromString, DateString } from '../../../../common/src/date_string.ts';

// `now` for the progress rules: the wall clock's time of day on the page's notion of today (the
// same date in production; a pinned date in stories, so what the rules record agrees with the
// date the screens show). Shared by the Learn exercises (issues #3473, #3481).
export function nowOn(today: DateString): Date {
  const now = new Date();
  const date = dateFromString(today);
  date.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
  return date;
}
